import { TextField, TextFieldProps, Tooltip, styled } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

type IProps<ControlData extends FieldValues = FieldValues> = {
  id: Path<ControlData>;
  label?: string;
  errorMessage?: string;
  control: Control<ControlData>;
  toolTipTitle?: string;
} & TextFieldProps;

// Styled TextField with absolute positioned helper text
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFormHelperText-root': {
    position: 'static',
    marginTop: 0,
    marginLeft: 0,
  },
}));

const FormInput = <T extends FieldValues = FieldValues>(props: IProps<T>) => {
  const { id, label, errorMessage, control, toolTipTitle = '', ...rest } = props;
  return (
    <Controller
      name={id}
      control={control}
      render={({ field }) =>
        toolTipTitle ? (
          <Tooltip title={toolTipTitle}>
            <StyledTextField
              {...field}
              value={field.value ?? ''}
              error={!!errorMessage}
              helperText={errorMessage}
              label={label}
              {...rest}
            />
          </Tooltip>
        ) : (
          <StyledTextField
            {...field}
            value={field.value ?? ''}
            error={!!errorMessage}
            helperText={errorMessage}
            label={label}
            {...rest}
          />
        )
      }
    />
  );
};

export default FormInput;
